import React from 'react'
import { Redirect } from 'react-router-dom'
import PrivateLayout from '../PrivateLayout/PrivateLayout'
import auth from '../../modules/auth'

/**
 * @extends PrivateLayout
 * @see https://simonsmith.io/reusing-layouts-in-react-router-4/
 */
const PrivateVerificationLayout = ({component: Component, ...rest}) => (
  <PrivateLayout {...rest} component={matchProps =>
    (auth.verifiedEmail() && auth.verifiedAuthenticationCode()) ? (
      <div>
        <Component {...matchProps}/>
      </div>
    ) : (
      <Redirect
        to={{
          pathname: "/logout"
        }}
      />
    )
  } />
)

export default PrivateVerificationLayout



// WEBPACK FOOTER //
// ./src/layouts/PrivateVerificationLayout/PrivateVerificationLayout.js